import { Component, inject, input, signal } from '@angular/core';
import { ResizeService } from '@core/services/mobile/resize.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-generic-info-user',
  imports: [TranslatePipe, DialogModule, SkeletonModule],
  templateUrl: './generic-info-user.component.html',
  styleUrl: './generic-info-user.component.scss',
  providers: [DialogService]
})
export class GenericInfoUserComponent {
  readonly resizeService = inject(ResizeService)

  readonly attivitaInfo = input.required<InfoInterface[]>();
  readonly loading = input<boolean>(false);

  readonly titleComponent = input<string>();

  public showDialogInfoData = signal<boolean>(false);

  /**
   * metodo pe mostrare le info utente con la visualizzazione mobile
   */
  showInfoData(): void {
    this.showDialogInfoData.set(true)
  }
}

export interface InfoInterface {
  title: string,
  value: string
}